import { __extends } from "tslib";
import { FXAATask } from './tasks/FXAATask';
import { FilterBase } from './FilterBase';
var FXAAFilter = /** @class */ (function (_super) {
    __extends(FXAAFilter, _super);
    /**
     * Creates a new FXAAFilter3D object
     * @param amount
     * @param stepSize The distance between samples. Set to -1 to autodetect with acceptable quality.
     */
    function FXAAFilter(amount, stepSize) {
        if (stepSize === void 0) { stepSize = -1; }
        var _this = _super.call(this) || this;
        _this._fxaaTask = new FXAATask(amount, stepSize);
        _this.addTask(_this._fxaaTask);
        return _this;
    }
    Object.defineProperty(FXAAFilter.prototype, "amount", {
        get: function () {
            return this._fxaaTask.amount;
        },
        set: function (value) {
            this._fxaaTask.amount = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FXAAFilter.prototype, "stepSize", {
        get: function () {
            return this._fxaaTask.stepSize;
        },
        set: function (value) {
            this._fxaaTask.stepSize = value;
        },
        enumerable: false,
        configurable: true
    });
    return FXAAFilter;
}(FilterBase));
export { FXAAFilter };
